// Request options for the booking flows' calls. None of the cancel,
// reschedule or bundle-dates endpoints needs a session (the booking id in the
// link is what lets the customer in), but a signed-in customer's bearer
// rides along like it does on v1's axios instance, so an endpoint that later
// starts checking it sees who is asking.

export function authInit(token: string | null | undefined, init: RequestInit = {}): RequestInit {
  if (!token) return init;
  return { ...init, headers: { ...(init.headers ?? {}), Authorization: `Bearer ${token}` } };
}
